module.exports = __webpack_public_path__ + "static/media/contactRightShape.14ac1c1e.svg";